import {PsoAgreementsModel} from "../base/pso-agreements.model";
import {IPsoFamilyAgreementFormFields} from "./pso-family-agreement.view-model.interface";
import {PsoFamilyAgreementModel} from "./pso-family-agreement.model";
import { AirlineWebapiResponse } from "../../../../../airline-webapi/airline-webapi-response";
import { PsoDeclarationJourneyDetailsRequest } from "../../../../../airline-webapi/requests/download-pso-declaration.request";
import { IDownloadBlobResponse } from "../../../../../airline-webapi/responses/download-blob.response";
import { BookingSessionStorageKeys } from "../../../storage/booking-session-storage-keys";
import {Lazy} from "../../../../../../utils/lazy";
import {PsoUserOptionsEnum} from "../../../../../flight-search/flight-search-controller/pso.enums";

export class PsoFamilyAgreementsModel extends PsoAgreementsModel<IPsoFamilyAgreementFormFields, PsoFamilyAgreementModel> {
    get confirmedStorageKey(): BookingSessionStorageKeys {
        return BookingSessionStorageKeys.psoFamiliesAgreementAccepted;
    }
    get downloadedStorageKey(): BookingSessionStorageKeys {
        return BookingSessionStorageKeys.psoFamiliesAgreementDownloaded;
    }
    get submittedStorageKey(): BookingSessionStorageKeys {
        return BookingSessionStorageKeys.psoFamiliesAgreementSubmitted;
    }

    private readonly _familyMembers: Lazy<PsoFamilyAgreementModel[]> = new Lazy<PsoFamilyAgreementModel[]>(() => {
        return this.booking.passengers.filter(p => p.passengerType.isAdult)
            .map(p => new PsoFamilyAgreementModel(p));
    });

    protected getAgreements(): PsoFamilyAgreementModel[] {
        if(this.booking.bookingStrategyAdapter.flightSearchController.psoUserOption === PsoUserOptionsEnum.Family) {
            return this._familyMembers.value;
        }

        return [];

    }
    protected async downloadSpecificDeclaration(journeyDetails: PsoDeclarationJourneyDetailsRequest): Promise<AirlineWebapiResponse<IDownloadBlobResponse>> {
        const request = {
            language: this.services.language.currentLanguage,
            JourneyDetails: journeyDetails,
            agreements: this.agreements.map(w => w.buildApiRequest())
        };

        return await this.services.airlineWebapi.downloadPsoFamilyDeclaration(request);
    }

}